import * as Yup from 'yup';

export const passwordSchema = Yup.string()
  .required()
  .matches(
    /(^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9\S]{8,}$)/,
    'Your password should be at least 8 characters, contain both uppercase and lowercase letters, and include at least 1 number.',
  );
